import '../components/quantity-selector.js';
import EVENT from '../enums/event.js';
import renderSectionFromResponse from '../utils/render-section-from-response.js';
import updateCartCount from '../utils/update-cart-count.js';

class CartPage extends HTMLElement {
  constructor() {
    super();

    this.$cartPage = document.querySelector('cart-modal');

    if (!this.$cartPage) {
      return;
    }

    this.registerEventListeners();
  }

  // eslint-disable-next-line class-methods-use-this
  registerEventListeners() {
    document.addEventListener(EVENT.CART.UPDATE, () => {
      fetch('/cart?sections=cart')
        .then(response => response.json())
        .then(response => {
          renderSectionFromResponse('[data-cart-page]', 'cart', response);
          updateCartCount();
        });
    });
  }
}

customElements.define('cart-page', CartPage);
